import {
    setCookie,
    initMenuTrigger,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow,
    initCounting
} from './functions';



import GLightbox from 'glightbox';




//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();


    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow ...
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();

    // init counting animation for span.counting
    initCounting();

    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            const scrollTarget = $(this).offset().top;
            $('html,body').animate({ 'scrollTop': scrollTarget + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder')[0].scrollTop = 0;
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        const viewportWidth = window.innerWidth;
        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (viewportWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if (target.length > 1) {
                var targetOffset = $(target).offset().top - 140;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 500);
            }
            return false;
        });


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }

        $('.gAtuty__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gAtuty__menuItem').removeClass('active');
            $(this).addClass('active');
            $('.gAtuty__contentItem').removeClass('active');
            $(`.gAtuty__contentItem#${target}`).addClass('active');

        });

        $("input[type='file'] ").on('change', function () {
            var fileName = $(this).val().split('\\').pop();
            $(this).parents('.contactform__field').find('.fileText').text(fileName);
            if (fileName.length > 0) {
                $(this).parents('.contactform__field').find('.file_delete').addClass('show');
            } else {
                $(this).parents('.contactform__field').find('.file_delete').removeClass('show');
            }
        });
        $(".file_delete").on('click', function () {
            $(this).parents('.contactform__field').find('input[type="file"]').val('');
            $(this).parents('.contactform__field').find('.fileText').text('');
            $(this).parents('.contactform__field').find('.file_delete').removeClass('show');
        });



        //rotator and sliders .....
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1600,
                autoplaySpeed: 3000,
                fade: true,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,
            });

        }

        const lightbox = GLightbox({
            selector: ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








